module.exports = {
      id: "pause-usage",
      viewBox: "0 0 31 30",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#pause",
      toString: function () {
        return this.url;
      }
    }